<template>
  <div id="donePage" class="center-div pageview">
    <lottie
      :options="defaultOptions"
      :height="400"
      :width="400"
      v-on:animCreated="handleAnimation"
    />
  </div>
</template>

<script>
import Lottie from "vue-lottie";
import * as animationData from "../../lottiefiles/trophy.json";
import Parse from "parse";
import confetti from "canvas-confetti";
window.confetti = confetti;

export default {
  components: {
    lottie: Lottie,
  },
  data() {
    return {
      defaultOptions: {
        animationSpeed: 0.1,
        loop: false,
        animationData: animationData.default,
      },
    };
  },
  methods: {
    verifyCompletion() {
      let _this = this;
      const Chore = Parse.Object.extend("Chore");
      const query = new Parse.Query(Chore);
      let kid = this.$root.$data.kids[_this.$route.query.kid];
      query.get(this.$route.query.chore).then(async (chore) => {
        gtag("event", "chore_completed");
        kid.set("points", kid.get("points") + chore.get("points"));
        chore.set("done", true);
        await kid.save();
        await chore.save();

        setTimeout(
          () =>
            _this.$router.replace({
              path: "/kids/",
              query: { ind: _this.$route.query.kid },
            }),
          3000
        );
        try {
          new Audio("./sounds/success.m4a").play();
        } catch {}
      });
    },
    animate() {
      var colors = [getCssVar("theme-color-1"), getCssVar("theme-color-2")];
      var end = Date.now() + 3 * 1000;

      // go Buckeyes!

      (function frame() {
        confetti({
          startVelocity: 75,
          particleCount: 2,

          angle: 60,
          spread: 55,
          origin: {
            x: 0,
            y: 1,
          },
          colors: colors,
        });
        confetti({
          startVelocity: 75,

          particleCount: 2,
          angle: 120,
          spread: 55,
          origin: {
            x: 1,
            y: 1,
          },
          colors: colors,
        });

        if (Date.now() < end) {
          requestAnimationFrame(frame);
        }
      })();
    },
    handleAnimation: function (anim) {
      this.anim = anim;
      this.anim.setSpeed(0.4);
    },

    stop: function () {
      this.anim.stop();
    },

    play: function () {
      this.anim.play();
    },

    pause: function () {
      this.anim.pause();
    },
  },
  mounted() {
    this.animate();
    this.verifyCompletion();
  },
};
</script>

<style lang="scss" scoped>
html,
body {
  padding: 0;
  margin: 0;
}

#donePage {
  background: var(--theme-color);
}
</style>
